import React, { useState } from 'react';
import { validateEmail, signupToWaitlist } from '../../utils';

const EmailPopup = ({ isOpen, onClose, onSuccess, referredBy }) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (emailError) {
      setEmailError(validateEmail(newEmail));
    }
  };

  const handleSubmit = async () => {
    const error = validateEmail(email);
    setEmailError(error);

    if (error) return;

    setIsLoading(true);
    try {
      const result = await signupToWaitlist(email.trim(), referredBy);
      if (result.success) {
        onSuccess(result.data);
        setEmail('');
        setEmailError('');
        onClose();
      } else {
        setEmailError(result.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Signup error:', error);
      setEmailError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '1rem',
      }}
      onClick={handleOverlayClick}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '1rem',
          padding: '2rem',
          maxWidth: '28rem',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
          position: 'relative',
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            backgroundColor: 'transparent',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#6B7280',
            padding: '0.25rem',
          }}
        >
          ×
        </button>

        {/* Content */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <h2
            style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              fontFamily: 'Inter, sans-serif',
              color: '#111827',
              marginBottom: '0.5rem',
            }}
          >
            Join the Waitlist
          </h2>
          <p
            style={{
              fontSize: '1rem',
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif',
              margin: 0,
            }}
          >
            Be the first to access FootyFlowStates when we launch
          </p>
        </div>

        {/* Form */}
        <div style={{ marginBottom: '1.5rem' }}>
          <input
            type="email"
            placeholder="Enter Your Email"
            value={email}
            onChange={handleEmailChange}
            onKeyPress={handleKeyPress}
            disabled={isLoading}
            style={{
              width: '100%',
              height: '3rem',
              padding: '0 1rem',
              borderRadius: '0.5rem',
              border: emailError ? '1px solid #EF4444' : '1px solid rgba(0, 0, 0, 0.4)',
              backgroundColor: emailError ? '#FEF2F2' : 'white',
              fontSize: '1rem',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 300,
              outline: 'none',
              marginBottom: emailError ? '0.5rem' : 0,
            }}
          />

          {/* Error Message */}
          {emailError && (
            <div
              style={{
                padding: '0.5rem',
                backgroundColor: '#FEF2F2',
                borderRadius: '0.25rem',
                color: '#EF4444',
                fontSize: '0.875rem',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              {emailError}
            </div>
          )}
        </div>

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          disabled={isLoading}
          style={{
            width: '100%',
            height: '3rem',
            backgroundColor: isLoading ? '#D1D5DB' : '#0D0E20',
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            fontSize: '1rem',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease',
          }}
        >
          {isLoading ? 'Joining...' : 'Join Waitlist'}
        </button>
      </div>
    </div>
  );
};

export default EmailPopup;